document.documentElement.classList.remove('no-js');


(function(){
  async function getCart(){
    const res = await fetch('/cart.js', {headers:{'Accept':'application/json'}});
    return res.json();
  }

  function updateCartCount(count){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = count;
      el.classList.toggle('is-zero', Number(count) === 0);
    });
  }

  function openCartToast(productTitle){
    const toast = document.getElementById('wb-cart-toast');
    if(!toast) return;
    const product = toast.querySelector('[data-cart-toast-product]');
    if(product && productTitle) product.textContent = productTitle + ' is toegevoegd.';
    toast.classList.add('is-open');
    toast.setAttribute('aria-hidden','false');
  }

  function closeCartToast(){
    const toast = document.getElementById('wb-cart-toast');
    if(!toast) return;
    toast.classList.remove('is-open');
    toast.setAttribute('aria-hidden','true');
  }

  document.addEventListener('click', function(e){
    if(e.target.closest('.wb-cart-toast-close') || e.target.closest('.wb-continue-shopping')){
      closeCartToast();
    }
    if(e.target === document.getElementById('wb-cart-toast')){
      closeCartToast();
    }
  });

  document.addEventListener('submit', async function(e){
    const form = e.target.closest('.wb-ajax-cart-form');
    if(!form) return;

    e.preventDefault();

    const submit = form.querySelector('button[type="submit"], input[type="submit"]');
    const originalText = submit ? (submit.textContent || submit.value) : '';
    if(submit){
      submit.disabled = true;
      if(submit.tagName === 'BUTTON') submit.textContent = 'Toevoegen…';
      else submit.value = 'Toevoegen…';
    }

    try{
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method:'POST',
        headers:{'Accept':'application/json'},
        body:formData
      });

      if(!res.ok) throw new Error('Add to cart failed');
      const added = await res.json();
      const cart = await getCart();
      updateCartCount(cart.item_count);
      openCartToast(added.product_title || added.title || '');
    }catch(err){
      // Fallback to normal Shopify behavior if AJAX fails
      form.submit();
      return;
    }finally{
      if(submit){
        submit.disabled = false;
        if(submit.tagName === 'BUTTON') submit.textContent = originalText;
        else submit.value = originalText;
      }
    }
  });

  // Sync badge on page load
  getCart().then(function(cart){ updateCartCount(cart.item_count); }).catch(function(){});
})();

document.addEventListener('change', function(e){
  if(e.target && e.target.classList.contains('wb-cart-qty')){
    const form = e.target.closest('form');
    if(form){
      const updateButton = form.querySelector('button[name="update"]');
      if(updateButton) updateButton.click();
      else {
        const hiddenUpdate = document.createElement('input');
        hiddenUpdate.type = 'hidden';
        hiddenUpdate.name = 'update';
        hiddenUpdate.value = '1';
        form.appendChild(hiddenUpdate);
        form.submit();
      }
    }
  }
});
